import React from "react";
import { UserCreatePage, USER_TYPES } from "../../modules/user-management";

const SystemUserCreate = () => (
  <UserCreatePage userType={USER_TYPES.SYSTEM} />
);

export default SystemUserCreate;
